import { forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ctaButtonStyle } from "@/lib/uiTheme";

/** Botón de acción principal (rojo / publicar) — colores desde plantilla. */
const CtaButton = forwardRef(function CtaButton({ className, style, ...props }, ref) {
  return (
    <Button
      ref={ref}
      className={cn("border-0 text-white hover:opacity-90", className)}
      style={{ ...ctaButtonStyle(), ...style }}
      {...props}
    />
  );
});

export default CtaButton;
